import { Collapse, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import TitleScroller from '../Home/TitleScroller';
import { useReviews } from '../Reviews/containers/ReviewsDataStore';
import ViewInListLink from '../UI/ViewInListLink';
import { useDownloads } from './containers/DownloadsDataStore';
import DownloadType from './DownloadType';
import { useHistory } from 'react-router-dom';
import {
	getDownloadedNotReviewedSku,
	getDownloadedReviewedSku,
} from './DownloadFilters';
import LocalStorageKeys from '../Preferences/LocalStorageKeys';
import { useYourBooksDrawer } from '../YourBooks/YourBooksDrawerContext';

const Panel = Collapse.Panel;

DownloadsCollapse.propTypes = {
	isMobile: PropTypes.func,
};

function DownloadsCollapse({ isMobile }) {
	const history = useHistory();
	const yourBooksDrawer = useYourBooksDrawer();

	const localStorageKey = LocalStorageKeys.expandedDownloadPanels;
	const localStorageValue = localStorage.getItem(localStorageKey);

	const getDownloadKeys = () => {
		return Object.keys(DownloadType).map(shelf => {
			return DownloadType[shelf].key;
		});
	};

	const [collapsedPanels, setCollapsedPanels] = React.useState(
		localStorageValue ? JSON.parse(localStorageValue) : getDownloadKeys(),
	);
	const isMobileSize = isMobile();

	React.useEffect(() => {
		localStorage.setItem(localStorageKey, JSON.stringify(collapsedPanels));
	}, [collapsedPanels]);

	const downloadsDataStore = useDownloads();
	const { isLoading, downloads } = downloadsDataStore.state;

	const reviewsDataStore = useReviews();
	const { reviews } = reviewsDataStore.state;

	const downloadSkus = downloads.map(item => item.sku);

	const reviewedSkus = reviews && reviews.map(item => item.sku);

	const renderPanel = (skus, downloadType) => {
		const filteredDownloads =
			skus &&
			skus.length > 0 &&
			downloads.filter(function(download) {
				return skus.includes(download.sku);
			});
		return (
			((skus && skus.length > 0) || downloadType.doShowIfZero) && (
				<Panel
					style={{ marginLeft: '-10px' }}
					header={downloadType.text}
					extra={skus.length}
					key={downloadType.key}>
					<TitleScroller
						titles={
							!isLoading && filteredDownloads && filteredDownloads
						}
						communityId={0}
					/>
					<div onClick={() => handleClick(downloadType.key)}>
						<ViewInListLink />
					</div>
				</Panel>
			)
		);
	};

	const handleClick = selectedKey => {
		downloadsDataStore.setSelectedMenuOption(selectedKey);
		history.push('/downloads');
		yourBooksDrawer && yourBooksDrawer.close();
	};

	const logChange = e => {
		setCollapsedPanels(e);
	};

	return (
		<>
			{downloads && downloads.length > 0 ? (
				<Collapse
					className={
						!isMobileSize
							? 'standard-collapse'
							: 'standard-collapse-mobile'
					}
					bordered={false}
					onChange={logChange}
					defaultActiveKey={collapsedPanels}
					activeKeys={collapsedPanels}
					expandIcon={({ isActive }) => (
						<Icon type="caret-right" rotate={isActive ? 90 : 0} />
					)}>
					{renderPanel(
						getDownloadedNotReviewedSku(downloadSkus, reviewedSkus),
						DownloadType.DownloadedNotReviewed,
					)}
					{renderPanel(
						getDownloadedReviewedSku(downloadSkus, reviewedSkus),
						DownloadType.DownloadedReviewed,
					)}
				</Collapse>
			) : (
				<div className="no-content-text">
					Titles you download will show up here
				</div>
			)}
		</>
	);
}

export default withIsMobile(DownloadsCollapse);
